import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Heading, Flex, Box, Text, Image, Button } from 'rebass';
import Img from 'gatsby-image';
import _map from 'lodash/map';
import TransitionsModal from './ModalFloors';

class TabsView extends React.Component {
  constructor() {
    super();
    this.state = { tabIndex: 0 };
  }

  render() {
    return (
      <Tabs
        className="floors"
        selectedIndex={this.state.tabIndex}
        onSelect={tabIndex => this.setState({ tabIndex })}
      >
        <TabList>
          {this.props.kerrospohjat.map(floor => (
            <Tab key={floor.id}>
              <Text display={['none', 'none', 'inline-block']}>
                {floor.otsikko}
              </Text>
              <Text display={['inline-block', 'inline-block', 'none']}>
                {floor.otsikkoMobiilissa}
              </Text>
            </Tab>
          ))}
        </TabList>
        {this.props.kerrospohjat.map(floor => (
          <TabPanel key={floor.id}>
            <TransitionsModal img={floor.kuva} />
          </TabPanel>
        ))}
      </Tabs>
    );
  }
}

export default TabsView;
